import { FormControl, FormItem } from "@/components/ui/form";
import { type ProductSelectLayout } from "@lib/config/types";
import { type IndividualProduct } from "@lib/products";
import { Swatch } from "./swatch";
import { Item as RadioItem } from "@radix-ui/react-radio-group";
import { getHasShade } from "../product-select-v2/shade-selector";

type ProductSwatchRadioProps = {
  product: IndividualProduct;
  selectedShade?: string;
  layout: ProductSelectLayout;
  swatchClassName?: string;
  container: HTMLElement | null;
};

function getSwatchProps(
  product: IndividualProduct,
  selectedShadeName: string | undefined,
  layout: ProductSelectLayout,
) {
  return {
    name: product.name,
    outOfStock: !product.hasStock,
    selected: product.name === selectedShadeName,
    shape: getHasShade(layout) ? layout.shade.shade_shape : "square",
    color:
      getHasShade(layout) && "shade" in product && product.shade
        ? product.shade
        : "",
  };
}

export function ProductSwatchRadio({
  product,
  selectedShade,
  layout,
  swatchClassName,
  container,
}: ProductSwatchRadioProps) {
  const id = product.allocationIds.join(",");

  return (
    <FormItem key={id}>
      <FormControl>
        <RadioItem
          className="w-full aspect-square block group"
          id={id}
          value={id}
        >
          <Swatch
            container={container}
            className={swatchClassName}
            {...getSwatchProps(product, selectedShade, layout)}
          />
        </RadioItem>
      </FormControl>
    </FormItem>
  );
}
